document.addEventListener("DOMContentLoaded", () => {
    const header = document.getElementById("main-header");
    const category = document.getElementById("category-header");
    const topbar = document.getElementById("shopify-section-announcement-bar");
    const searchDetails = document.querySelector("details"); // <-- ta balise <details>
    const headerInitialOffset = header.offsetTop;
    let lastScrollY = window.scrollY;
    let ticking = false;
    let keepVisible = false;
  
    // Empêche la disparition lors du clic sur un <summary>
    header.querySelectorAll("summary").forEach(summary => {
      summary.addEventListener("click", () => {
        keepVisible = true;
        header.classList.remove("hide");
      });
    });
  
    function onScroll() {
      const currentScrollY = window.scrollY;
  
      if (currentScrollY > headerInitialOffset) {
        if (!header.classList.contains("stuck")) header.classList.add("stuck");
  
        if (!keepVisible) {
          if (currentScrollY > lastScrollY) {
            // Scroll vers le bas → cache la topbar
            category.classList.add("hide");
            topbar.classList.add("topbar--hidden");
            header.classList.remove("fix");
          } else {
            // Scroll vers le haut → affiche la topbar
            category.classList.remove("hide");
            topbar.classList.remove("topbar--hidden");
            header.classList.add("fix");
          }
        }
      } else {
        // Tout en haut
        header.classList.remove("stuck", "hide", "fix");
        category.classList.remove("hide");
        topbar.classList.remove("topbar--hidden");
        keepVisible = false;
      }
  
      lastScrollY = currentScrollY;
      ticking = false;
    }
  
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    });
  
    // ✅ Masque la topbar si la page est chargée déjà scrollée
    if (window.scrollY > headerInitialOffset) {
      topbar.classList.add("topbar--hidden");
      category.classList.add("hide");
      header.classList.add("stuck");
    }
  
    // ✅ Observe la fermeture du <details> de recherche
    if (searchDetails) {
      const observer = new MutationObserver(() => {
        // Quand la recherche se ferme (open retiré)
        if (!searchDetails.hasAttribute("open")) {
          requestAnimationFrame(onScroll);
        }
      });
  
      observer.observe(searchDetails, { attributes: true, attributeFilter: ["open"] });
    }
  });
  